const productUploadTemplate =
  'https://aisle-optix-pub.s3.eu-north-1.amazonaws.com/AisleOptix-template.xlsx';
const upcUploadTemplate =
  'https://aisle-optix-pub.s3.eu-north-1.amazonaws.com/AisleOptix-UPC.xlsx';
const salesUploadTemplate =
  'https://aisle-optix-pub.s3.eu-north-1.amazonaws.com/AisleOptix-template-sales-data.xlsx';

export default {
  productUploadTemplate,
  upcUploadTemplate,
  salesUploadTemplate,
};
